var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.tutors)?_c('div',{staticClass:"container-grid section__coaches-page-coach"},_vm._l((_vm.tutors),function(tutor){return _c('div',{key:tutor.id,staticClass:"container-grid__item grid-2"},[_c('tutor-item',{key:tutor.id,attrs:{"tutor":tutor,"show-status":false,"show-experience":false,"show-achievements":true}})],1)}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }